import { render, staticRenderFns } from "./joinAuth.vue?vue&type=template&id=37ea4a9b&scoped=true"
import script from "./joinAuth.vue?vue&type=script&lang=js"
export * from "./joinAuth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ea4a9b",
  null
  
)

export default component.exports